import { PaletteMode, useTheme } from '@mui/material'

export const usePaletteMode = (): PaletteMode => {
  const theme = useTheme()

  return theme.palette.mode
}
